<template>
    <div>
        <b-modal
            ref="modalBanner"
            centered
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            v-model="bannerCourier.show"
            @hidden="closeModalBannerCourier"
            size="custom-banner"
            body-class="p-0"
            header-class="p-1"
            
        >
            <div class="row">
                <div class="col-lg-12 text-center">
                    <b-carousel
                        v-model="slide"
                        :interval="4000"
                        controls
                        indicators
                        background="#ababab"
                        :img-width="bannerCourier.size.width"
                        :img-height="bannerCourier.size.height"
                        style="text-shadow: 1px 1px 2px #333;"
                        @sliding-start="onSlideStart"
                        @sliding-end="onSlideEnd"
                    >
                        <b-carousel-slide v-for="(campaign, index) in bannerCourier.campaigns" :key="index">
                            <template #img>
                                <img 
                                    :src="campaign.banner.image_full_path" 
                                    alt="ImageBannerCourier" 
                                    :width="bannerCourier.size.width" 
                                    :height="bannerCourier.size.height"
                                >
                            </template>
                        </b-carousel-slide>
                    </b-carousel>
                    <div class="col-lg-12">
                        <div class="d-flex justify-content-end">
                            <b-link class="font-weight-bold text-decoration-underline" 
                                @click="notShowHours()">
                                ไม่แสดงอีก 1 ชั่วโมง
                            </b-link>
                        </div>
                    </div>
                    <div class="w-100 py-2">
                        <b-button variant="success"
                            class="px-6" 
                            @click="closeModalBannerCourier">
                            ตกลง
                        </b-button>
                    </div>
                </div>
            </div> 
        </b-modal>
    </div>
</template>
<script>
import { setCookie } from "@/helpers/util.js";

export default {
    name: "ModalBannerCourier" ,
    props: {
        bannerCourier: Object,
    },
    data(){
        return{
            slide: 0,
            sliding: null,
            root: null
        }
    },
    mounted(){
        this.root = document.body;
    },
    methods: {
        closeModalBannerCourier(){
            this.bannerCourier.show = false
        },
        onSlideStart() {
            this.sliding = true
        },
        onSlideEnd() {
            this.sliding = false
        },
        notShowHours(){
            setCookie(`banner_courier_${this.bannerCourier.courierCode}`, 1, '1hr')
            this.closeModalBannerCourier()
        }
    },
    watch: {
        'bannerCourier.show': {
            handler: function() {
                this.$nextTick(() => {
                    this.root.style.setProperty("--banner-width", `${this.bannerCourier.size.width}px`);
                    this.root.style.setProperty("--banner-height", `${this.bannerCourier.size.height}px`);
                })
            },
            immediate: true
        }
    }
}
</script>	
<style>
    .modal .modal-custom-banner {
        max-width: var(--banner-width);
        max-height: var(--banner-height);
    }
</style>